export enum AccountEmailNotificationPreferenceEnum {
  EMAILS_OFF = "emails_off",
  EMAILS_ON = "emails_on",
  PRE_QUALIFIED_LEADS_ONLY = "pre_qualified_leads_only",
  UNQUALIFIED_LEADS_ONLY = "unqualified_leads_only",
}
